const TuvaluSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112643)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20.0001 40C8.95438 40 0 31.0456 0 20C0 20.0048 20.0001 0.0021875 20.0001 0C31.0456 0 40 8.95437 40 20Z"
        fill="#338AF3"
      />
      <path d="M9.56494 19.9995H16.3104L10.4345 13.043L9.56494 15.6516V19.9995Z" fill="#0052B4" />
      <path d="M20 16.311L13.0435 9.56543H19.9999L20 16.311Z" fill="#0052B4" />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0001 10.4348C20.0001 6.91563 20.0001 4.60969 20.0001 0H19.9967C8.9525 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3107 20H19.9466C19.9645 19.9822 19.9823 19.9644 20.0002 19.9465C20.0002 18.5991 20.0002 17.3968 20.0002 16.3108L14.1241 10.4348H20.0001Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38957 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M21.8286 33.043L22.2603 34.3716H23.6573L22.5272 35.1927L22.9589 36.5212L21.8286 35.7002L20.6985 36.5212L21.1302 35.1927L20 34.3716H21.3969L21.8286 33.043Z"
        fill="#FFDA44"
      />
      <path
        d="M32.9542 24.3486L33.3858 25.6772H34.7828L33.6527 26.4984L34.0845 27.8269L32.9542 27.0059L31.8241 27.8269L32.2558 26.4984L31.1255 25.6772H32.5224L32.9542 24.3486Z"
        fill="#FFDA44"
      />
      <path
        d="M35.7422 11.3047L36.1739 12.6333H37.5708L36.4408 13.4544L36.8724 14.7829L35.7422 13.9619L34.6121 14.7829L35.0438 13.4544L33.9136 12.6333H35.3105L35.7422 11.3047Z"
        fill="#FFDA44"
      />
      <path
        d="M36.4317 20.8701L36.8633 22.1988H38.2603L37.1302 23.0199L37.5619 24.3484L36.4317 23.5274L35.3016 24.3484L35.7333 23.0199L34.603 22.1988H36L36.4317 20.8701Z"
        fill="#FFDA44"
      />
      <path
        d="M23.832 29.9189L25.0769 30.5532L26.0646 29.5654L25.8462 30.945L27.0908 31.5793L25.7109 31.7979L25.4924 33.1776L24.8584 31.9329L23.4785 32.1515L24.4663 31.1638L23.832 29.9189Z"
        fill="#FFDA44"
      />
      <path
        d="M23.832 24.7021L25.0769 25.3364L26.0646 24.3486L25.8462 25.7283L27.0908 26.3625L25.7109 26.5811L25.4924 27.9608L24.8584 26.7161L23.4785 26.9347L24.4663 25.947L23.832 24.7021Z"
        fill="#FFDA44"
      />
      <path
        d="M28.1791 28.0448L29.424 28.6791L30.4118 27.6914L30.1933 29.071L31.4379 29.7052L30.0581 29.9238L29.8396 31.3036L29.2055 30.0588L27.8257 30.2775L28.8134 29.2898L28.1791 28.0448Z"
        fill="#FFDA44"
      />
      <path
        d="M28.1791 16.875L29.424 17.5092L30.4118 16.5215L30.1933 17.9012L31.4379 18.5353L30.0581 18.7539L29.8396 20.1337L29.2055 18.889L27.8257 19.1076L28.8134 18.1198L28.1791 16.875Z"
        fill="#FFDA44"
      />
      <path
        d="M32.3935 16.7422L33.6384 17.3764L34.6261 16.3887L34.4076 17.7684L35.6523 18.4025L34.2725 18.6211L34.0539 20.0009L33.4199 18.7562L32.04 18.9748L33.0278 17.987L32.3935 16.7422Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112643">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TuvaluSvg;
